export default "__VITE_ASSET__CDmhFA35__"